export { useGetSectionsListQuery, useSectionsGetSectionInfoQuery } from './queries'
